module.exports = __webpack_public_path__ + "img/icone-corn.1ea7c102.svg";